import { render, staticRenderFns } from "./BankMenu.vue?vue&type=template&id=128f15c3&scoped=true"
import script from "./BankMenu.vue?vue&type=script&lang=js"
export * from "./BankMenu.vue?vue&type=script&lang=js"
import style0 from "./BankMenu.vue?vue&type=style&index=0&id=128f15c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f15c3",
  null
  
)

export default component.exports